import React from 'react';
import './ValidateLoader.css';
import Loader from './preloader-6.gif';

const ValidateLoader = () => {
    return (
        <div className="validate-loader__container">
            <img src={Loader} alt="validate-loader" />
        </div>
    );
};

ValidateLoader.propTypes = {};

export default React.memo(ValidateLoader);
